import api from './api'

/*
 * Cliente del Historial (expediente del vehículo). Como `catalogos.js`: sin
 * alertas globales; los errores llegan a la pantalla, que decide cómo
 * presentarlos. Contrato: CONTRATO-API.md de la tarea historial-expediente.
 */

const lista = (valor) => (Array.isArray(valor) ? valor : [])

/* Código HTTP de un error del interceptor (`error.response`) o de axios. */
export function estadoHttp(error) {
  const estado = Number(error?.status ?? error?.response?.status)
  return Number.isFinite(estado) && estado > 0 ? estado : null
}

/* 404 (no existe) o 400 (id inválido): el auto no se puede abrir. */
export function esNoEncontrado(error) {
  const estado = estadoHttp(error)
  return estado === 404 || estado === 400
}

export default {
  /* GET /api/historial/buscar?q=&limite= → { q, clientes, autos, ordenes } */
  buscar(q, { limite } = {}) {
    const params = { q: String(q ?? '').trim() }
    if (limite) params.limite = limite
    return api.get('/api/historial/buscar', { params }).then(({ data }) => {
      if (!data || typeof data !== 'object' || Array.isArray(data)) {
        throw new Error('Respuesta de búsqueda inválida')
      }
      return {
        q: typeof data.q === 'string' ? data.q : params.q,
        clientes: lista(data.clientes),
        autos: lista(data.autos),
        ordenes: lista(data.ordenes),
      }
    })
  },

  /* GET /api/historial/vehiculo/:id → expediente completo del auto */
  expediente(id) {
    return api.get(`/api/historial/vehiculo/${encodeURIComponent(String(id ?? ''))}`).then(({ data }) => {
      if (!data || !data.vehiculo || !Array.isArray(data.visitas)) {
        throw new Error('Respuesta de expediente inválida')
      }
      return {
        ...data,
        dueno: data.dueno || null,
        otrosAutos: lista(data.otrosAutos),
        resumen: data.resumen || {},
        ultimaVisita: data.ultimaVisita || null,
      }
    })
  },
}
